export default "__VITE_ASSET__e2c62a01__"